// Generate .ics calendar file for wedding events
export const generateCalendarFile = () => {
  const events = [
    {
      title: 'Polina & Evgeniy Wedding - Welcome Dinner',
      start: '20260906T160000Z', // September 6, 2026, 4:00 PM UTC
      end: '20260906T210000Z',   // September 6, 2026, 9:00 PM UTC
      location: 'Talici Hill, Montenegro',
      description: 'Welcome dinner to kick off our three-day celebration. Dress code: Smart-Casual/Casual'
    },
    {
      title: 'Polina & Evgeniy Wedding - Ceremony & Reception',
      start: '20260907T140000Z', // September 7, 2026, 2:00 PM UTC
      end: '20260908T020000Z',   // September 8, 2026, 2:00 AM UTC (afterparty)
      location: 'Talici Hill, Montenegro',
      description: 'Wedding ceremony, dinner, and celebration. Dress code: Summer Outdoor Black Tie'
    },
    {
      title: 'Polina & Evgeniy Wedding - Farewell Brunch & Pool Party',
      start: '20260908T100000Z', // September 8, 2026, 10:00 AM UTC
      end: '20260908T160000Z',   // September 8, 2026, 4:00 PM UTC
      location: 'Talici Hill, Montenegro',
      description: 'Farewell brunch and pool party. Dress code: Casual/Beachwear. Don\'t forget your swimsuit!'
    }
  ];

  // Generate ICS content
  let icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Polina & Evgeniy Wedding//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'X-WR-CALNAME:Polina & Evgeniy Wedding',
    'X-WR-TIMEZONE:UTC',
    'X-WR-CALDESC:Three days of celebration in Montenegro'
  ];

  events.forEach((event, index) => {
    icsContent.push(
      'BEGIN:VEVENT',
      `UID:${Date.now()}-${index}@polinaevgeniy.wedding`,
      `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z`,
      `DTSTART:${event.start}`,
      `DTEND:${event.end}`,
      `SUMMARY:${event.title}`,
      `LOCATION:${event.location}`,
      `DESCRIPTION:${event.description}`,
      'STATUS:CONFIRMED',
      'SEQUENCE:0',
      'BEGIN:VALARM',
      'TRIGGER:-P1D',
      'ACTION:DISPLAY',
      'DESCRIPTION:Reminder: Wedding event tomorrow!',
      'END:VALARM',
      'END:VEVENT'
    );
  });

  icsContent.push('END:VCALENDAR');

  return icsContent.join('\r\n');
};

export const downloadCalendar = () => {
  const icsContent = generateCalendarFile();
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'polina-evgeniy-wedding.ics';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
